import { chuHienTai } from './theo-nganh.ts'

/** Chuỗi "Hồ sơ buổi làm" trong tờ chi tiết lịch (N3). Tiếng Việt có dấu, câu ngắn. */
export const H = {
  lanTruoc: (ngay: string) => `Lần trước · ${ngay}`,
  chuaCoLanTruoc: 'Khách chưa có ghi chú lần trước.',
  // RETRO bảo mật 4: hồ sơ gắn Zalo theo số, quầy chưa xác nhận đúng người.
  choXacNhanZalo:
    'Khách này chưa được xác nhận đúng người. Vào màn Khách, mục Tìm khách để xác nhận trước khi xem lần trước.',
  xemAnh: (n: number) => `Xem ảnh ${n}`,
  ghiChuNhan: 'Ghi chú buổi này',
  get ghiChuGoiY() {
    return chuHienTai().viDuGhiChuBuoi
  },
  luuGhiChu: 'Lưu ghi chú',
  daLuuGhiChu: 'Đã lưu ghi chú. Lần sau thợ sẽ thấy.',
  chupAnh: 'Chụp ảnh',
  dangTaiAnh: 'Đang lưu ảnh…',
  daLuuAnh: 'Đã lưu ảnh vào hồ sơ khách.',
  /** Bằng chứng sau khi lưu: đếm ảnh đã lưu trong lần mở tờ này + nút xem từng ảnh. */
  anhBuoiNay: (n: number) => `Ảnh buổi này: ${n}`,
  xemAnhBuoiNay: (n: number) => `Xem ảnh buổi này, số ${n}`,
  /** Hiện NGAY CẠNH nút "Chụp ảnh" sau khi ghi khách đồng ý (không dồn xuống cuối tờ). */
  huongDanSauDongY: 'Khách đã đồng ý. Bạn bấm “Chụp ảnh” để chụp.',
  loiMangAnh: 'Mạng đang chậm nên chưa lưu được ảnh. Bạn bấm “Chụp ảnh” để gửi lại nhé.',
  loiMangHetGioAnh:
    'Mạng chậm nên chưa chắc ảnh đã lưu. Bạn đợi một chút; nếu chưa thấy “Ảnh buổi này” thì bấm “Chụp ảnh” chụp lại nhé.',
  anhQuaNang: 'Ảnh quá nặng. Bạn chụp lại hoặc chọn ảnh nhỏ hơn nhé.',
  khongNenDuocAnh: 'Máy chưa chuẩn bị được ảnh này. Bạn thử chụp lại nhé.',
  // Phiên bản câu hỏi: v2-2026-10-30 (apps/api/src/repo/quay-lai.ts CAU_HOI_DONG_Y_ANH) — đổi câu thì tăng số.
  // v2: "tối đa" vì ảnh lưu tạm trên đĩa máy chủ (khi kho đám mây lỗi) chỉ giữ 30 ngày; con số là hạn dài nhất đã nói với khách.
  hoiDongY: 'Khách đồng ý cho tiệm lưu ảnh vào hồ sơ?',
  hoiDongYPhu: (ngay: number) =>
    `Ảnh dùng để thợ xem lại mẫu lần sau, chỉ nhân viên tiệm mở được, tự xoá sau tối đa ${
      ngay >= 365 ? '12 tháng' : `${ngay} ngày`
    }. Khách đổi ý thì tiệm xoá hết ảnh ngay.`,
  /** N1 (soát bảo mật R2): chỉ hiện khi kho ảnh khách của máy chủ là R2 (ngoài Việt Nam). Một câu ngắn, nối sau câu phụ — không thêm ô / chạm. */
  luuNgoaiVN: 'Ảnh lưu ở máy chủ đám mây ngoài Việt Nam.',
  khachDongY: 'Khách đồng ý',
  khongChup: 'Không chụp',
  /** Lỗi ĐỊNH DẠNG (ảnh HEIC mà trình duyệt không mở được…): nói cách khắc phục. Lỗi mạng có câu riêng (`loiMangAnh`). */
  khongDocDuocAnh: 'Không đọc được ảnh này. Bạn thử chụp lại hoặc chọn ảnh JPG, PNG nhé.',
} as const
